import NavigationBarContainer from './navigationBar.container';

export default NavigationBarContainer;
